import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\PublicController::whatsappFormatter
* @see app/Http/Controllers/PublicController.php:58
* @route '/outils/formatteur-whatsapp'
*/
export const whatsappFormatter = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: whatsappFormatter.url(options),
    method: 'get',
})

whatsappFormatter.definition = {
    methods: ["get","head"],
    url: '/outils/formatteur-whatsapp',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PublicController::whatsappFormatter
* @see app/Http/Controllers/PublicController.php:58
* @route '/outils/formatteur-whatsapp'
*/
whatsappFormatter.url = (options?: RouteQueryOptions) => {
    return whatsappFormatter.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PublicController::whatsappFormatter
* @see app/Http/Controllers/PublicController.php:58
* @route '/outils/formatteur-whatsapp'
*/
whatsappFormatter.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: whatsappFormatter.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::whatsappFormatter
* @see app/Http/Controllers/PublicController.php:58
* @route '/outils/formatteur-whatsapp'
*/
whatsappFormatter.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: whatsappFormatter.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PublicController::whatsappFormatter
* @see app/Http/Controllers/PublicController.php:58
* @route '/outils/formatteur-whatsapp'
*/
const whatsappFormatterForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: whatsappFormatter.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::whatsappFormatter
* @see app/Http/Controllers/PublicController.php:58
* @route '/outils/formatteur-whatsapp'
*/
whatsappFormatterForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: whatsappFormatter.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PublicController::whatsappFormatter
* @see app/Http/Controllers/PublicController.php:58
* @route '/outils/formatteur-whatsapp'
*/
whatsappFormatterForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: whatsappFormatter.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

whatsappFormatter.form = whatsappFormatterForm

const tools = {
    whatsappFormatter: Object.assign(whatsappFormatter, whatsappFormatter),
}

export default tools